import QuantityInputGroup from 'components/ui/QuantityInputGroup'
import Button from 'components/ui/Button'
import { CartItemInput } from 'global-graphql-types'
import Loading from 'components/Loading'

import { ItemQuestionsFragment } from './types/ItemQuestionsFragment'
import { useCartItemEstimation } from './types/CartItemEstimation'

type ItemType = ItemQuestionsFragment['item']

type Props = {
  item: ItemType
  itemInput: CartItemInput
  buttonText: string
  forUpdate: boolean
  submitting: boolean
  isDelete: boolean
  canOrder: boolean
}

const BaseItemModalBottom = ({
  item,
  forUpdate,
  canOrder,
  buttonText,
  submitting,
  itemInput,
  isDelete
}: Props) => {
  const { data, loading } = useCartItemEstimation({
    fetchPolicy: 'cache-first',
    variables: {
      item: itemInput
    }
  })

  return (
    <div className="bg-gray-50 border-gray-100 sticky bottom-0 left-0 right-0 p-5 border-t border-solid">
      <div className="flex justify-between">
        <p className="font-bold">{item.name}</p>
        <div className="flex flex-col items-end">
          {data?.cartItemEstimation && !loading ? (
            <p>{data.cartItemEstimation.total.formatted}</p>
          ) : (
            <Loading size="small" text="" />
          )}
          {data?.cartItemEstimation?.taxIncluded && (
            <p className="text-sm text-gray-500">*Tax Included</p>
          )}
        </div>
      </div>
      <div className="flex justify-between mt-2">
        <div className="w-1/3">
          <QuantityInputGroup
            hasGroup={false}
            itemName={item.name}
            maxValue={20}
            minValue={forUpdate ? 0 : 1}
            name="quantity"
          />
        </div>
        <div className="w-2/3 pl-5">
          <Button
            color={isDelete ? 'danger' : 'primary'}
            disabled={submitting || !canOrder}
            type="submit"
            variant="contained"
            fullWidth
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default BaseItemModalBottom
